import { defineStore } from 'pinia'
import { notificationRepository } from '@/service/repository/notificationRepository'
import store from '@/store'

export const useNotificationStore = defineStore('notification', {
	state: () => ({
		notificationsType: {
			SECOND_DRINK: 'upselling_drinks_reminder',
			KIOSK_WALK_IN: 'kiosk_walk_in',
			KIOSK_QR_SCAN: 'kiosk_qr_scan',
			CONSUMER_READY_TO_ORDER: 'customer_ready_to_order'
		},

		notificationUpsellingActions: {
			NOTHING: 'nothing',
			CART: 'cart'
		},
		// Recent muestra los últimos 10min
		// Main notifications array containing the unified response
		notifications: { history: [], pending: [] }, // Contains { history: [...], pending: [...] }

		isLoadingNotifications: false,
		isLoadingTicketNotifications: false,
		lastUpdateTime: null
	}),

	getters: {
		// Main getter
		getNotifications: (state) => state.notifications,

		// Get history and pending from the unified response
		getHistoryNotifications: (state) => state.notifications?.history || [],
		getPendingNotifications: (state) => state.notifications?.pending || [],

		// Get pending notifications filtered by type
		getPendingTicketNotifications: (state) => {
			return state.notifications?.pending?.filter((notification) => notification.type === 'ticket_request') || []
		},
		getPendingUpsellingNotifications: (state) => {
			const zoneFilterActive = store.getters['copilot/zoneFilter']

			const notifications = state.notifications?.pending?.filter((notification) => notification.type === 'upselling_drinks_reminder') || []

			if (!zoneFilterActive) {
				return notifications
			}

			// Get selected zones from Vuex store
			const selectedZones = store.getters['copilot/selectedZoneFilter'] || []

			// If no zones are selected, return all notifications
			if (selectedZones.length === 0) {
				return notifications
			}

			// Filter notifications by selected zones
			return notifications.filter((notification) => {
				// Check if notification has rooms and if any room name matches selected zones
				if (notification.rooms && Array.isArray(notification.rooms)) {
					return notification.rooms.some((room) => selectedZones.includes(room.name))
				}
				return false // If no rooms, exclude the notification
			})
		},

		getAllPendingAccountKioskNotification: (state) => {
			const zoneFilterActive = store.getters['copilot/zoneFilter']

			const notifications = state.notifications?.pending?.filter((notification) => notification.type === state.notificationsType.KIOSK_WALK_IN || notification.type === state.notificationsType.KIOSK_QR_SCAN) || []

			if (!zoneFilterActive) {
				return notifications
			}

			// Get selected zones from Vuex store
			const selectedZones = store.getters['copilot/selectedZoneFilter'] || []

			// If no zones are selected, return all notifications
			if (selectedZones.length === 0) {
				return notifications
			}

			// Filter notifications by selected zones
			return notifications.filter((notification) => {
				// Check if notification has rooms and if any room name matches selected zones
				if (notification.rooms && Array.isArray(notification.rooms)) {
					return notification.rooms.some((room) => selectedZones.includes(room.name))
				}
				return false // If no rooms, exclude the notification
			})
		},

		getAllCustomerReadyToOrderNotifications: (state) => {
			const zoneFilterActive = store.getters['copilot/zoneFilter']

			const notifications = state.notifications?.pending?.filter((notification) => notification.type === state.notificationsType.CONSUMER_READY_TO_ORDER) || []

			if (!zoneFilterActive) {
				return notifications
			}

			// Get selected zones from Vuex store
			const selectedZones = store.getters['copilot/selectedZoneFilter'] || []

			// If no zones are selected, return all notifications
			if (selectedZones.length === 0) {
				return notifications
			}

			// Filter notifications by selected zones
			return notifications.filter((notification) => {
				// Check if notification has rooms and if any room name matches selected zones
				if (notification.rooms && Array.isArray(notification.rooms)) {
					return notification.rooms.some((room) => selectedZones.includes(room.name))
				}
				return false // If no rooms, exclude the notification
			})
		},

		getNotificationsForType: (state, typeArray) => {
			const zoneFilterActive = store.getters['copilot/zoneFilter']

			const notifications = state.notifications?.pending?.filter((notification) => notification.type === typeArray) || []

			if (!zoneFilterActive) {
				return notifications
			}

			// Get selected zones from Vuex store
			const selectedZones = store.getters['copilot/selectedZoneFilter'] || []

			// If no zones are selected, return all notifications
			if (selectedZones.length === 0) {
				return notifications
			}

			// Filter notifications by selected zones
			return notifications.filter((notification) => {
				// Check if notification has rooms and if any room name matches selected zones
				if (notification.rooms && Array.isArray(notification.rooms)) {
					return notification.rooms.some((room) => selectedZones.includes(room.name))
				}
				return false // If no rooms, exclude the notification
			})
		},


		// Legacy getter for backward compatibility
		getTicketNotifications: (state) => {
			return state.notifications?.pending?.filter((notification) => notification.type === 'ticket_request') || []
		},

		// Upselling drinks reminder getters (migrated from Vuex)
		getAllNotificationUpsellingDrinksReminder: (state) => {
			const zoneFilterActive = store.getters['copilot/zoneFilter']

			const notifications = state.notifications?.pending?.filter((notification) => notification.type === 'upselling_drinks_reminder' && notification.status === 0) || []

			if (!zoneFilterActive) {
				return notifications
			}
			// Get selected zones from Vuex store
			const selectedZones = store.getters['copilot/selectedZoneFilter'] || []

			// If no zones are selected, return all notifications
			if (selectedZones.length === 0) {
				return notifications
			}

			// Filter notifications by selected zones
			return notifications.filter((notification) => {
				// Check if notification has rooms and if any room name matches selected zones
				if (notification.rooms && Array.isArray(notification.rooms)) {
					return notification.rooms.some((room) => selectedZones.includes(room.name))
				}
				return false // If no rooms, exclude the notification
			})
		},

		getAllReservationsNotificationUpsellingDrinksReminder: (state) => {
			const notifications = state.notifications?.pending?.filter((notification) => notification.type === 'upselling_drinks_reminder' && notification.status === 0) || []

			// Get selected zones from Vuex store
			const selectedZones = store.getters['copilot/selectedZoneFilter'] || []

			// Filter notifications by selected zones
			let filteredNotifications = notifications
			if (selectedZones.length > 0) {
				filteredNotifications = notifications.filter((notification) => {
					// Check if notification has rooms and if any room name matches selected zones
					if (notification.rooms && Array.isArray(notification.rooms)) {
						return notification.rooms.some((room) => selectedZones.includes(room.name))
					}
					return false // If no rooms, exclude the notification
				})
			}

			// Get copilot reservations from Vuex store
			const copilotReservations = store.getters['copilot/reservations'] || []

			return filteredNotifications
				.map((notification) => {
					const reservationWid = notification.reservations?.[0]?.wid
					const reservation = copilotReservations.find((r) => r.id === reservationWid)

					return {
						...reservation,
						notificationId: notification.id
					}
				})
				.filter((r) => r != null)
		},

		// Get drinks for a specific reservation (migrated from Vuex)
		getAllDrinksForReservation: () => (reservation) => {
			if (reservation && reservation.cartSession) {
				const productOrders = reservation.cartSession?.productOrders || []
				return productOrders.flatMap((order) => order.items || []).filter((item) => {
					if (item.type) {
						return item.type.toLowerCase() === 'bebida'
					}
				})
			}

			return []
		},

		// Loading states
		getIsLoadingNotifications: (state) => state.isLoadingNotifications,
		getIsLoadingTicketNotifications: (state) => state.isLoadingTicketNotifications,
		getLastUpdateTime: (state) => state.lastUpdateTime,

		// Zone filtering
		getSelectedZoneFilter: () => {
			return store.getters['copilot/selectedZoneFilter'] || []
		}
	},

	actions: {
		// Main action for the unified notifications endpoint
		async loadNotifications(date = null) {
			try {
				this.isLoadingNotifications = true
				// Assign the entire response to notifications array
				this.notifications = await notificationRepository.getNotifications(date)
				this.lastUpdateTime = new Date()
			} catch (error) {
				console.error('Error loading notifications:', error)
			} finally {
				this.isLoadingNotifications = false
			}
		},

		// Legacy actions for backward compatibility (kept for existing code)
		async loadRecentNotifications() {
			try {
				this.isLoadingNotifications = true
				const notifications = await notificationRepository.getRecentNotifications()
				this.notifications = { history: notifications, pending: [] }
				this.lastUpdateTime = new Date()
			} catch (error) {
				console.error('Error loading recent notifications:', error)
			} finally {
				this.isLoadingNotifications = false
			}
		},

		async loadTicketRequestNotifications() {
			try {
				this.isLoadingTicketNotifications = true
				const ticketNotifications = await notificationRepository.getTicketRequestNotifications()
				this.notifications = { history: [], pending: ticketNotifications }
				this.lastUpdateTime = new Date()
			} catch (error) {
				console.error('Error loading ticket request notifications:', error)
			} finally {
				this.isLoadingTicketNotifications = false
			}
		},

		async loadAllNotifications() {
			// Use the new unified endpoint instead of separate calls
			await this.loadNotifications()
		},

		// Add a new notification (for real-time updates)
		addNotification(notification) {
			// Add to history notifications
			if (!this.notifications.history) {
				this.notifications.history = []
			}
			this.notifications.history.unshift(notification)
		},

		// Update notification status (e.g., when acknowledged)
		updateNotification({ id, updates }) {
			// Update in history notifications
			if (this.notifications.history) {
				const index = this.notifications.history.findIndex((n) => n.id === id)
				if (index !== -1) {
					this.notifications.history[index] = { ...this.notifications.history[index], ...updates }
				}
			}
			// Update in pending notifications
			if (this.notifications.pending) {
				const index = this.notifications.pending.findIndex((n) => n.id === id)
				if (index !== -1) {
					this.notifications.pending[index] = { ...this.notifications.pending[index], ...updates }
				}
			}
		},

		// Remove notification (e.g., when dismissed)
		removeNotification(id) {
			// Remove from history notifications
			if (this.notifications.history) {
				this.notifications.history = this.notifications.history.filter((n) => n.id !== id)
			}
			// Remove from pending notifications
			if (this.notifications.pending) {
				this.notifications.pending = this.notifications.pending.filter((n) => n.id !== id)
			}
		},

		// Clear all notifications
		clearNotifications() {
			this.notifications = { history: [], pending: [] }
		},

		// Legacy action for backward compatibility
		async acknowledgeNotifications(notificationId, notificationData) {
			try {
				const response = await notificationRepository.acknowledgeNotification(notificationId, notificationData)

				if (response.ok) {
					// Remove the acknowledged notification
					this.removeNotification(notificationId)
					return response
				} else {
					return response
				}
			} catch (error) {
				console.error('Error acknowledging notification:', error)
				throw error
			}
		}
	}
})
